import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { empty } from 'rxjs';
import * as _lodash from 'lodash';
import { ProfileHttpService } from '../../../../profiles/services/profile-http.service';
import { ToastrService } from 'ngx-toastr';
import { SupplierOtherCreditorProfile } from '@admin/supplier-other-creditor/models/supplier-other-creditor-profile';
import { Profile } from '../../../../profiles/models/profile';
import { map, catchError } from 'rxjs';
import { SupplierOtherCreditorTypes } from '@feature/suppliers/models/supplier-other-creditor-types';

@Component({
  selector: 'mojo-supplier-other-creditor-editor',
    templateUrl: './supplier-other-creditor-editor.component.html'
})
export class SupplierOtherCreditorEditorComponent implements OnInit {
  dialogTitle = 'Supplier Profile Assignment';
  @Input() profiles: Profile[] = [];

  @Output() onSaveComplete = new EventEmitter();
  @Output() onCancel = new EventEmitter();

    private supplierOtherCreditorProfile: SupplierOtherCreditorProfile;

  selectedProfile: Profile;
  allowActions = true;
  displayDialog: boolean;

  get selectedName(): string {
      return this.supplierOtherCreditorProfile ? this.supplierOtherCreditorProfile.name : '';
    }

  get selectedType(): string {
    return this.supplierOtherCreditorProfile ? this.supplierOtherCreditorProfile.type : '';
  }

    save(): void {
      const request = this.supplierOtherCreditorProfile.type == SupplierOtherCreditorTypes.Supplier
        ? this.profileHttpService.associateProfileWithSupplier(this.supplierOtherCreditorProfile.ref,
          this.selectedProfile.id)
        : this.profileHttpService.associateProfileWithCreditor(this.supplierOtherCreditorProfile.ref,
          this.selectedProfile.id);

      request.pipe(
      map(() => {
        this.displayDialog = false;
        this.allowActions = true;
          this.messageService.success(`${this.supplierOtherCreditorProfile.type} '${this.supplierOtherCreditorProfile.name}' updated`,  `${this.supplierOtherCreditorProfile.type} Updated`);
        this.onSaveComplete.emit(null);
      }),
      catchError(() => {
          this.messageService.error(`${this.supplierOtherCreditorProfile.type} '${this.supplierOtherCreditorProfile.name}' not saved`, 'Save Error');
        this.allowActions = true;
        return empty();
      })
    ).subscribe();

  }

  cancel(): void {
    this.displayDialog = false;
    this.onCancel.emit();
  }

    showDialog(supplierOtherCreditorProfile: SupplierOtherCreditorProfile): void {
        this.dialogTitle = `${supplierOtherCreditorProfile.type} Profile Assignment`;
        this.supplierOtherCreditorProfile = supplierOtherCreditorProfile;
    this.selectedProfile = this.supplierOtherCreditorProfile.profile;
    this.displayDialog = true;
  }

  ngOnInit() { }

  constructor(private profileHttpService: ProfileHttpService,
    private messageService: ToastrService) {
  }
}
